import { render, staticRenderFns } from "./DemoFormLayoutHorizontalIcon.vue?vue&type=template&id=13bea5c0"
import script from "./DemoFormLayoutHorizontalIcon.vue?vue&type=script&lang=js"
export * from "./DemoFormLayoutHorizontalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports